module.exports = __webpack_public_path__ + "img/FI.2545e6e0.png";